<template>
    <div>
        <p class="mb-3 text-center font-bold text-highlight-100">
            {{ label }}
        </p>
        <div class="radio-group">
            <label class="option" v-for="( optionLabel, option ) in options" :key="option">
            <span class="custom-radio">
                <input
                    type="radio"
                    :class="{ 'has-error': $v.local.$error }"
                    :name="name"
                    :readonly="readonly"
                    :tabindex="[ readonly ? '-1' : '0' ]"
                    :value="option"
                    :checked="option === local"
                    @input="update($event.target.value)"
                    @blur="validate"
                />
                <span class="check-mark"/>
            </span>
                {{ optionLabel }}
            </label>
        </div>
    </div>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import inputField from '@/mixins/inputField'

export default {
    props: {
        name: {
            type: String,
            required: true,
        },
        options: {
            type: Object,
            required: true,
        },
    },
    mixins: [inputField],
    validations: {
        local: {
            required,
        },
    },
    watch: {
        value() {
            this.local = this.value
            this.$emit('update:validation', !this.$v.$invalid)
        },
    },
    created() {
        if (!this.$v.local.$dirty && this.local) {
            this.validate()
        }
    },
    methods: {
        validate() {
            this.$v.$touch()
            this.$emit('update:validation', !this.$v.$invalid)
        },
    },
}
</script>

<style scoped>
    .radio-group {
        @apply flex w-full justify-center
    }

    .radio-group > .option {
        @apply mx-3 text-highlight-100
    }

    .radio-group .custom-radio {
        @apply inline-flex justify-center items-center w-4 h-4 rounded-full border border-solid border-highlight-100 align-text-bottom mr-1
    }

    .radio-group .custom-radio > input[type="radio"] {
        @apply hidden
    }

    .radio-group .custom-radio > .check-mark {
        @apply hidden w-2 h-2 rounded-full bg-highlight-100
    }

    .radio-group .custom-radio > input[type="radio"]:checked + .check-mark {
        @apply block
    }
</style>
